<template>
  <div class="play-bot">
    <div class="play-box-content">
      <div class="play-left">
        <div class="text">{{ name }}</div>
        <div>
          <my-TokenLogo styleCss="color:#ffffff" :price="price"></my-TokenLogo>
        </div>
      </div>
      <div class="play-right">
        <div class="text">{{ go }}</div>
        <div class="go" @click="goPlay">
          <img src="@/assets/mybox/home/fulie.png" />
        </div>
      </div>
    </div>
    <div>
      <my-payment
        :isShow="playIsShow"
        @hide="goPlay"
        :detatils="detatils"
      ></my-payment>
    </div>
  </div>
</template>
<script>
export default {
  name: "PlayButton",
  props: {
    name: { type: String, default: "" },
    go: { type: String, default: "GO" },
    price: { type: Number, default: 0 },
  },

  data() {
    return {
      playIsShow: false,
      detatils: {
        name: this.name,
        go: this.go,
        price: this.price,
      },
    };
  },
  methods: {
    goPlay() {
      this.playIsShow = !this.playIsShow;
    },
  },
};
</script>
<style lang="scss" scoped>
.play-bot {
  width: 100%;
  .play-box-content {
    width: 100%;
    height: 1.1rem;
    padding: 0 0.3rem;
    font-size: 0.32rem;
    display: flex;
    color: #ffffff;
    justify-content: space-between;
    align-items: center;
    background: #171718;
    border-radius: 27px;
  }
  .play-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
      margin-right: 0.2rem;
    }
  }
  .play-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
      margin-right: 0.2rem;
    }
  }
}
</style>
